import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Icon,
    Box,
} from "@mui/material";

interface ConfirmActionDialogProps {
    open: boolean;
    title: string;
    description: string;
    confirmText?: string;
    cancelText?: string;
    icon?: string;
    color?: "primary" | "secondary" | "error" | "warning" | "info" | "success";
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
    open,
    title,
    description,
    confirmText = "Continue",
    cancelText = "Cancel",
    icon = "warning",
    color = "error",
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: (theme) => theme.palette[color]?.main }}>
                    <Icon>{icon}</Icon>
                    {title}
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography>{description}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{cancelText}</Button>
                <Button onClick={onConfirm} variant="contained" color={color} autoFocus>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};